import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@up2stay/up2promo-ui';

import type { LocationDetailDict } from './location-detail-types';

type LocationDetailExternalLinksConfirmProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  linkedProductCount: number;
  dict: LocationDetailDict['linkedProducts'] | undefined;
  onCancel: () => void;
  onConfirm: () => void;
};

export function LocationDetailExternalLinksConfirm({
  open,
  onOpenChange,
  linkedProductCount,
  dict,
  onCancel,
  onConfirm,
}: LocationDetailExternalLinksConfirmProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {dict?.confirmTitle ?? 'Change location settings?'}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {dict?.confirmDescription?.replace(
              '{count}',
              String(linkedProductCount),
            ) ?? `${linkedProductCount} product(s) rely on these settings.`}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>
            {dict?.cancel ?? 'Cancel'}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {dict?.confirmSave ?? 'Save anyway'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
